import { render, staticRenderFns } from "./DetailVoyage.vue?vue&type=template&id=16a5efd9&scoped=true&"
import script from "./DetailVoyage.vue?vue&type=script&lang=js&"
export * from "./DetailVoyage.vue?vue&type=script&lang=js&"
import style0 from "./DetailVoyage.vue?vue&type=style&index=0&id=16a5efd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a5efd9",
  null
  
)

export default component.exports